import { XMarkIcon } from '@heroicons/react/24/outline';

import useBodyScrollLock from '../hooks/useBodyScrollLock';
import { SLIDE_OVER_TOP_OFFSET_STYLE } from './slideOverTransition';

// Full-viewport chart container for phones. Locks page scroll while open and
// gives the chart the whole viewport, so landscape rotation yields a usable
// inspection surface. Children are mounted only while open, so the uplot
// instance inside sizes itself to the overlay via its own ResizeObserver.
export default function FullScreenChartOverlay({ open, onClose, title, children }) {
  useBodyScrollLock(open);

  if (!open) return null;

  return (
    // Top pinned below the playground banner (fixed, z-60) so the header and
    // close button are never covered; the var is 0 outside the playground.
    <div
      className="fixed inset-x-0 bottom-0 z-50 flex flex-col overscroll-contain bg-surface dark:bg-gray-870 p-4 landscape:p-2 pl-[max(env(safe-area-inset-left),1rem)] pr-[max(env(safe-area-inset-right),1rem)] landscape:pl-[max(env(safe-area-inset-left),0.5rem)] landscape:pr-[max(env(safe-area-inset-right),0.5rem)]"
      style={SLIDE_OVER_TOP_OFFSET_STYLE}
    >
      <div className="flex items-center justify-between pb-2 landscape:pb-1">
        <h2 className="text-sm font-semibold text-gray-900 dark:text-gray-100">{title}</h2>
        <button
          type="button"
          onClick={onClose}
          aria-label="Close full-screen chart"
          className="rounded-full p-2 text-gray-500 hover:bg-gray-100 dark:text-gray-400 dark:hover:bg-gray-800"
        >
          <XMarkIcon className="h-5 w-5" aria-hidden="true" />
        </button>
      </div>
      <div className="relative flex-1 min-h-0">{children}</div>
      {/* Pointless once already rotated, and landscape height is scarce */}
      <p className="pt-2 text-center text-[11px] text-gray-400 dark:text-gray-500 landscape:hidden">
        Rotate your phone for more detail
      </p>
    </div>
  );
}
